import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=63aa7aa6&scoped=true&"
import script from "./js/forgot-password.js?vue&type=script&lang=js&"
export * from "./js/forgot-password.js?vue&type=script&lang=js&"
import style0 from "./forgot-password.vue?vue&type=style&index=0&id=63aa7aa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aa7aa6",
  null
  
)

export default component.exports